module.exports = __webpack_public_path__ + "img/progress.ddcd606b.png";